import React from 'react'
import { Tooltip, TooltipProps } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useCarouselFunctions } from '../../dashboard/templatelibrary/utils/useCarouselFunctions';

interface GlobalTooltipProps {
    placement?: TooltipProps["placement"], 
    arrow?: boolean,  
    title: TooltipProps["title"], 
    open?: boolean,
    children: React.ReactElement<any, any>, 
    offset?: number,
    disableHoverListener?: boolean,
    enterTouchDelay?: number,
    leaveTouchDelay?: number,
    onOpen?: TooltipProps["onOpen"],
    onClose?: TooltipProps["onClose"],
    onMouseLeave?: TooltipProps["onMouseLeave"],
    onClick?: TooltipProps["onClick"],
} 

const GlobalTooltip: React.FC<GlobalTooltipProps> = (props) => {

    const { placement, arrow, title, children, open, offset, disableHoverListener, enterTouchDelay, leaveTouchDelay, onOpen, onClose, onMouseLeave, onClick } = props;
    
    const { isMobileScreen } = useCarouselFunctions();
    
    const offsetDistance = typeof offset === 'number' ? offset : 0;

    const useStyles = makeStyles(() => ({
        customTooltip: {
            backgroundColor: '#FFF',
            color: '#000',
            fontSize: '12px',
            padding: '6px 12px',
            borderRadius: 5,
            margin: "0px",
            boxShadow: "0px 0px 3px rgba(0,0,0,0.75)",

            '@media (max-width: 1000px)': {
                fontSize: '10px',
                maxWidth: '250px',
                maxHeight: '350px',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
            },
        },
        arrow: {
            "&::before": {
                color: '#FFF', 
                boxShadow: "0px 0px 3px rgba(0,0,0,0.75)",
            }
        }
    }));
    const classes = useStyles();

    return (
        <>
            <Tooltip 
                placement={placement ?? "top"} 
                arrow={isMobileScreen ? false : arrow} 
                title={title} 
                open={open}
                disableHoverListener={disableHoverListener ?? false}
                enterTouchDelay={enterTouchDelay ?? 0}
                leaveTouchDelay={leaveTouchDelay ?? 4000}
                onOpen={onOpen}
                onClose={onClose}
                onMouseLeave={onMouseLeave}
                onClick={onClick}
                PopperProps={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, offsetDistance]
                            }
                        }
                    ]
                }}
                classes={{ 
                    tooltip: classes.customTooltip,
                    arrow: classes.arrow,
                }}
            >
                {children}
            </Tooltip>
        </>
    )
}

export default GlobalTooltip
